var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{key:_vm.requestId},[_c('ClinicDeatil',{attrs:{"backRoute":"DoctorClinic","isClinicJoinRequest":true,"alreadyResponded":_vm.alreadyResponded,"alreadyRespondedMessage":_vm.alreadyRespondedMessage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }